var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "span",
    {
      staticClass: "tooltip tooltip-icon",
      class: _vm.cssClass,
      attrs: {
        "data-tooltip": "",
        tabindex: "0",
        "aria-label": _vm.cleanText,
      },
    },
    [
      _vm.isHtml
        ? _c("span", {
            staticClass: "tooltip-content",
            domProps: {
              innerHTML: _vm._s(_vm.text),
            },
          })
        : _c(
            "span",
            {
              staticClass: "tooltip-content",
            },
            [_vm._v(_vm._s(_vm.text))]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }